import { HelpCircle } from 'lucide-react'
import type { ReactElement } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

export interface ExplicacaoProps {
  /** O que o número significa, em uma frase. */
  oQueE: string
  /** Como é calculado — a fórmula, em português. */
  formula: string
  /** Campo(s) exatos de onde o dado vem. */
  origem: string
  /** Regra de negócio aplicada que não é óbvia pela fórmula. */
  regra?: string
  /** Nome da fonte no rótulo "Origem no …" (default: HubSpot). */
  fonte?: string
  rotulo: string
}

/**
 * "De onde vem esse número?" — a pergunta que o executivo faz quando o valor
 * surpreende. Sem resposta à mão, o painel perde confiança na primeira dúvida.
 */
export function Explicacao({
  oQueE,
  formula,
  origem,
  regra,
  fonte = 'HubSpot',
  rotulo,
}: ExplicacaoProps): ReactElement {
  return (
    <Popover>
      <PopoverTrigger
        aria-label={`Como é calculado: ${rotulo}`}
        className="text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:ring-ring inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2"
      >
        <HelpCircle className="h-4 w-4" aria-hidden />
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 space-y-3 text-sm">
        <p className="font-medium leading-snug">{oQueE}</p>

        <dl className="space-y-2">
          <div>
            <dt className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
              Cálculo
            </dt>
            <dd className="mt-0.5 font-mono text-xs leading-relaxed">{formula}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
              Origem no {fonte}
            </dt>
            <dd className="mt-0.5 font-mono text-xs leading-relaxed">{origem}</dd>
          </div>
          {regra ? (
            <div>
              <dt className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
                Regra aplicada
              </dt>
              <dd className="mt-0.5 text-xs leading-relaxed">{regra}</dd>
            </div>
          ) : null}
        </dl>
      </PopoverContent>
    </Popover>
  )
}
